import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { requestPricehelper } from "../apiRequests/requestPricehelper";
import { requestStep5 } from "../apiRequests/requestStep5";
import { requestStorage } from "../apiRequests/requestStorage";

export const requestSummary_Aggregated = createAsyncThunk(
  "thunks/requestSummary_Aggregated",
  async (data = { urlParamKey: null }, thunkAPI) => {
    const state = thunkAPI.getState();
    const { requests, Uterum } = state;
    const { apiConfigs } = requests;

    (!data || Object.keys(data).length === 0) &&
      console.error(
        `Unexpected data in thunks/requestSummary_Aggregated: ${data}`
      );

    Object.keys(data).some(
      (key) =>
        key !== "urlParamKey" &&
        console.error(
          `Unexpected key in thunks/requestSummary_Aggregated: ${key}`
        )
    );

    const { urlParamKey } = data;

    let aggregatedResponse = null;

    if (urlParamKey) {
      // via URL path: /gotosummary
      aggregatedResponse = await requestStorage({
        method: "get",
        apiConfigs,
        params: {
          Key: urlParamKey,
        },
        onSuccess: (response) => {
          const savedUterum = response.data;

          return requestStep5({
            apiConfigs,
            data: savedUterum,
            onSuccess: (response) => {
              const cgeObj = response.data;
              const { ErpArticleNumbers } = cgeObj;

              return requestPricehelper({
                apiConfigs,
                tentativeData: ErpArticleNumbers,
                onSuccess: (response) => {
                  const pricehelperObj = response.data;

                  return {
                    data: {
                      cgeObj,
                      pricehelperObj,
                    },
                  };
                },
              });
            },
          });
        },
      });
    } else {
      // via URL path: /step5
      aggregatedResponse = await requestStep5({
        apiConfigs,
        data: Uterum,
        onSuccess: (response) => {
          const cgeObj = response.data;
          const { ErpArticleNumbers } = cgeObj;

          return requestPricehelper({
            apiConfigs,
            tentativeData: ErpArticleNumbers,
            onSuccess: (response) => {
              const pricehelperObj = response.data;

              return {
                data: {
                  cgeObj,
                  pricehelperObj,
                },
              };
            },
          });
        },
      });
    }

    return aggregatedResponse.data;
  },
  conditionRuleset
);
